import type { BackendRouteDefinition } from '../types';
import type { DeleteMatter } from '@cloudFunctions/types/firms/deleteMatter';

// Served by `api-core-node` at `DELETE /api/firms/matters/:matterId`.
// No callable counterpart exists in `cloudFunctions/` — this route was
// introduced after the codebase-wide callable→api migration was already
// underway, so it was never deployed in callable form. The matter id moves
// through the URL path; there is no body.
//
// Cascade-delete is naturally idempotent (a retry after a partial success
// just deletes whatever orphans remain; a retry after a full success
// returns "Matter not found"), so no `Idempotency-Key` header is needed.
export const deleteMatterRoute = {
  transport: 'api',
  method: 'DELETE',
  path: '/firms/matters/:matterId',
  params: ({ matterId }: DeleteMatter.Props) => ({ matterId }),
} as const satisfies BackendRouteDefinition;
